<template>
    <div class="v-setting">
        <div class="v-setting__label">
            {{ label }}
        </div>

        <div class="v-setting__input">
            <slot></slot>
        </div>

    </div>

</template>

<script>

    import vLightSwitch from "./vLightswitch"

    export default {
        name: "vSetting",
        components: {
            vLightSwitch
        },
        data() {
            return {
                val: this.value
            }
        },
        props: {
            label: {type: String, default: ""}
        },
        methods: {
            emit($event) {
                console.log($event);
                this.$emit('input', $event)
            }
        },
        watch: {
            value() {
                this.val = this.value;
            }
        }

    }
</script>

<style lang="scss">
    .v-setting {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .5em 0;

        &__label {
            font-weight: 600;
            font-size: .85em;
        }

        &__input {
            width: 16em;
        }
    }


</style>